import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IStaff,
  IStaffListRequest,
  IStaffCreateRequest,
  IStaffUpdateRequest,
  StaffState,
} from "@/types/staff";
import CustomRequest from "../customRequest";

const actions: ActionTree<StaffState, RootState> = {
  async salesGet({ commit }, staff_id: number) {
    await CustomRequest.get<IStaff>({
      uri: `/sales/staff/${staff_id}`,
      commit,
      target: "single",
    });
  },

  async salesGetList(
    { commit },
    datas: { partner_id: number; params: IStaffListRequest }
  ) {
    await CustomRequest.get<IPagination<IStaff>>({
      uri: `/sales/partner/${datas.partner_id}/staff`,
      commit,
      target: "pagination",
      params: datas.params,
    });
  },

  async salesUpdate(
    { commit },
    datas: { staff_id: number; params: IStaffUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IStaff>({
      uri: `/sales/staff/${datas.staff_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },
  async salesCreate(
    { commit },
    datas: { partner_id: number; params: IStaffCreateRequest }
  ) {
    const { error } = await CustomRequest.post<IStaff>({
      uri: `/sales/partner/${datas.partner_id}/staff`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },
  async salesDelete({ commit }, staff_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/staff/${staff_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
